<template>
  <div class="edu-frame">
    <edu-nav-bar title="活动详情" :show="show" @showPopup="show=true"
                 @hidePopup="show=false"></edu-nav-bar>
    <div style="height: calc(100vh - 50px - 46px);overflow: auto;font-size: 14px;">
<!--      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-if="activity.promoPic1 != null && activity.promoPic1 != ''"><img :src="activity.promoPic1"></van-swipe-item>
        <van-swipe-item v-if="activity.promoPic2 != null && activity.promoPic2 != ''"><img :src="activity.promoPic2"></van-swipe-item>
        <van-swipe-item v-if="activity.promoPic3 != null && activity.promoPic3 != ''"><img :src="activity.promoPic3"></van-swipe-item>
        <van-swipe-item v-if="activity.promoPic4 != null && activity.promoPic4 != ''"><img :src="activity.promoPic4"></van-swipe-item>
        <van-swipe-item v-if="activity.promoPic5 != null && activity.promoPic5 != ''"><img :src="activity.promoPic5"></van-swipe-item>
        <van-swipe-item v-if="activity.promoPic6 != null && activity.promoPic6 != ''"><img :src="activity.promoPic6"></van-swipe-item>
        <van-swipe-item v-if="activity.promoPic7 != null && activity.promoPic7 != ''"><img :src="activity.promoPic7"></van-swipe-item>
        <van-swipe-item v-if="activity.promoPic8 != null && activity.promoPic8 != ''"><img :src="activity.promoPic8"></van-swipe-item>
        <van-swipe-item v-if="activity.promoPic9 != null && activity.promoPic9 != ''"><img :src="activity.promoPic9"></van-swipe-item>
      </van-swipe>-->
      <div class="activity-title">{{activity.activityName}}</div>
      <div style="margin-left: 10px;color:gray;margin-bottom: 3px;">发布组织：{{ activity.organisers }}</div>
      <div style="margin-left: 10px;color:gray;display: flex;align-items: center;">推荐星级：
        <div class="item-desc-detail" v-if="activity != null && activity.star != null">
            <van-icon name="star" v-for="star in activity.star" :key="star" color="orange"/>
            <van-icon name="star-o" v-for="star2 in (5 - activity.star)" :key="star2+'none'"/>
        </div>
      </div>
      <hr style="width: 95%;margin: 10px auto;background: #e8e8e8;border: 0px;height: 1px;"/>

            <div style="margin-left: 10px;font-size: 16px;">活动信息</div>
            <div style="margin-left: 10px;color:gray;margin-bottom: 3px;">报名时间：{{activity.beginTime | filterDate}} - {{activity.endTime | filterDate}}</div>
            <div style="margin-left: 10px;color:gray;margin-bottom: 3px;">活动时间：{{activity.actBeginTime | filterDate}} - {{activity.actEndTime | filterDate}}</div>
            <hr style="width: 95%;margin: 10px auto;background: #e8e8e8;border: 0px;height: 1px;"/>

            <template v-for="(detail, index) in activityDetails" >
              <div :key="'detail_'+index">
                <div style="margin-left: 10px;font-size: 16px;">{{ detail.itemName }}</div>
                <div style="margin: 10px 0px;">
                  <template v-for="(item, i) in detail.items">
                    <div :key="'item_' + i" style="display: flex;flex-direction: column;margin: 6px 0px;">
                      <div style="margin-left: 10px;color:gray;margin-bottom: 3px;margin-bottom: 3px;">时间段{{i+1}}：{{ item.itemName }}</div>
                      <div style="margin-left: 10px;color:gray;margin-bottom: 3px;margin-bottom: 3px;">招募人数：<span style="color: dodgerblue;">剩{{ item.storQty - item.buyQty }}</span>/{{ item.storQty }}人</div>
                      <div style="margin-left: 10px;color:gray;margin-bottom: 3px;margin-bottom: 3px;">描述：{{ item.itemDesc }}</div>
                    </div>
                  </template>

                </div>
              </div>
            </template>
            <hr style="width: 95%;margin: 10px auto;background: #e8e8e8;border: 0px;height: 1px;"/>

            <div style="margin-left: 10px;font-size: 16px;">活动介绍</div>
            <div style="margin-left: 10px;color:gray;margin-bottom: 3px;">
              <div v-html="activity.intro" class="activity-content-detail-all">
              </div>
            </div>
            <hr style="width: 95%;margin: 10px auto;background: #e8e8e8;border: 0px;height: 1px;"/>


    </div>
    <div style="background-color: white;height: 50px;">
      <van-button :disabled="submitEnabled==false" :loading="submitting" type="danger" block size="large" @click="toPay">报名</van-button>
    </div>
  </div>
</template>
<script>
import EduNavBar from "@/components/VolunteerEduNavBar.vue";
import { Swipe, SwipeItem, Button, Icon } from "vant";
import ActivityApi from "@/api/ActivityApi";
import XEUtils from "xe-utils";
import wx from "weixin-js-sdk";
import Tools from "@/api/Tools";
export default {
  name: 'actinfo',
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
    VanButton: Button,
    VanIcon: Icon,
    EduNavBar
  },
  filters: {
    filterDate(date) {
      return date != null && date != '' ? XEUtils.toDateString(date, 'yyyy-MM-dd HH:mm') : ''
    }
  },
  data() {
    return {
      showType: '... 展开',
      activity: {},
      submitting: false,
      activityDetails: [],
      show:false,
      cust: Tools.getCurCust(),
      submitEnabled: false
    }
  },
  methods: {
    changeShowType() {
      if (this.showType.indexOf('展开') > -1) {
        this.showType = '<< 收起'
      } else if (this.showType.indexOf('收起') > -1) {
        this.showType = '... 展开'
      }
    },
    toPay() {
      if (this.submitting == true) {
        return;
      }

      var buyMaster = { activitySettingMasterId : this.$route.query.activitySettingMasterId, payType: 0, custId: this.cust.custId, totalMoney: 0, details: [] }
      this.submitting = true
      ActivityApi.buyVolunteerActivity(buyMaster).then(response => {
        this.submitting = false
        if (response.code == 100) {
          if (response.res.data == 'success') {
            this.$router.push({ name: 'cjhdsuccess' })
          } else {
            this.$dialog.alert({message: "报读课程失败，请重试。"})
          }
        }
      }).catch(() => {
        this.submitting = false
      })

    },
    /*toPay() {
      this.$router.push({ name: 'cjhdsubmit', query: { activitySettingMasterId: this.activity.activitySettingMasterID } })
    },*/
    getActivityDetail() {
      var activitySettingMasterId = this.$route.query.activitySettingMasterId
      console.log('getActivityDetail')
      ActivityApi.getActivityDetails(activitySettingMasterId).then(response => {
        // console.log(response.res)
        this.activityDetails = response.res
        if (response.res != null) {
          for(var i = 0; i < response.res.length; i++) {
            response.res[i].selectItem = ''
            response.res[i].selectItems = []
            response.res[i].switchCheck = false
            if (response.res[i].items!= null) {
              for (var j = 0; j < response.res[i].items.length; j++) {
                // response.res[i].items[j].isCheck = false
                response.res[i].items[j].qty = 1
              }
            }
            response.res[i].items = JSON.parse(JSON.stringify(response.res[i].items))
          }

        }

      })
    },
    setShareConfig() {
      // alert('测试分享。')
      var stitle = this.activity.activityName

      wx.updateAppMessageShareData({
        title: stitle, // 分享标题
        desc: '粤美·巾帼故事妈妈志愿者平台', // 分享描述
        link: 'https://edu.gdfezx.com/qxapi/edu/wechat/oauthforact?page=actinfo&activitySettingMasterId=' + this.activity.activitySettingMasterID, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'http://edumgr.gdfezx.com/img/logo.73f12c01.png', // 分享图标
        success: function () {
          // 设置成功
          // alert('分享给朋友成功。')
        },
        cancel: function() {
          // alert('cancel');
        },
        fail: function(res) {
          // alert('fail'+JSON.stringify(res));
          console.log(res)
        }
      })

      wx.updateTimelineShareData({
        title: stitle, // 分享标题
        link: 'https://edu.gdfezx.com/qxapi/edu/wechat/oauthforact?page=actinfo&activitySettingMasterId=' + this.activity.activitySettingMasterID,// window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'http://edumgr.gdfezx.com/img/logo.73f12c01.png', // 分享图标
        success: function () {
          // 设置成功
          // alert('分享到朋友圈成功。')
        },
        cancel: function() {
          // alert('cancel');
        },
        fail: function(res) {
          // alert('fail'+JSON.stringify(res));
          console.log(res)
        }
      })
    }
  },
  mounted() {
    var openId = this.$route.query.openid
    // alert(openId)
    if (openId != null && openId != '') {
      sessionStorage.setItem('openId', openId)
    }


    var activitySettingMasterId = this.$route.query.activitySettingMasterId
    // console.log(activitySettingMasterId)
    this.submitting = true
    ActivityApi.getActivityById(activitySettingMasterId).then(response => {
      this.submitting = false
      this.activity = response.res
      this.activity.intro = this.activity.intro.replaceAll('\n', '</br>').replaceAll('<img', '<img style="width: 100%" ').replaceAll('class="ql-indent-2"', 'style="margin-left: 60px"')
      var beginTime = parseFloat(XEUtils.toDateString(this.activity.beginTime, 'yyyyMMddHHmmss'))
      var endTime = parseFloat(XEUtils.toDateString(this.activity.endTime, 'yyyyMMddHHmmss'))
      var now = parseFloat(XEUtils.toDateString(new Date(), 'yyyyMMddHHmmss'))
      if (!(beginTime <= now && now <= endTime)) {
        this.submitEnabled = false
      } else {
        this.submitEnabled = true
      }

      this.setShareConfig()
      this.getActivityDetail()
    }).catch(() => {
      this.submitting = false
    })
  }
}
</script>
<style scoped>
.edu-frame {
  background-color: white;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  text-align: center;
  background-color: #39a9ed;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
}

.van-swipe-item img {
  width: 100%;
}

.activity-title {
  height: 38px;
  display: flex;
  align-items: center;
  padding: 0px 10px;
  background-color: white;
  font-weight: bold;
  font-size: 16px;
}

.activity-time {
  height: 50px;
  background-color: white;
  margin-top: 15px;
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  justify-content: center;
}

.activity-content {
  background-color: white;
  margin: 15px 0px;
  display: flex;
  padding: 15px 20px;
  flex-direction: column;

}
.activity-content-detail {
  display: -webkit-box;  /*  display: -webkit-box; 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示  */
  -webkit-box-orient: vertical; /*  -webkit-box-orient 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式  */
  -webkit-line-clamp: 10; /*  -webkit-line-clamp用来限制在一个块元素显示的文本的行数 */
  overflow: hidden;
}

.activity-content-detail-all {

}

.activity-content-detail-all img{
  width: 100%;
}

.ql-syntax {
  white-space: pre-wrap; /*css-3*/
  white-space: -moz-pre-wrap; /*Mozilla,since1999*/
  white-space: -o-pre-wrap; /*Opera7*/
  word-wrap: break-word; /*InternetExplorer5.5+*/
}
.ql-indent-2 {
  margin-left: 20px !important;
}
</style>
